import React, { useEffect, useState } from 'react'
import styles from './UploadDoc.module.scss'
import { useParams } from 'react-router-dom'
import IconPDF from '@/components/Atoms/Icons/FileTypes/IconPDF'
import IconDOC from '@/components/Atoms/Icons/FileTypes/IconDOC'
import IconXLS from '@/components/Atoms/Icons/FileTypes/IconXLS'
import IconImage from '@/components/Atoms/Icons/FileTypes/IconIMAGE'
import IconFile from '@/components/Atoms/Icons/FileTypes/IconFILE'

import IconCancel from '@/components/Atoms/Icons/IconCancel'
import { Dialog, notifyError } from '@/components'
import { useDeleteFeaturesDocMutation } from './service'

type Props = {
  documents: {
    id: number
    name: string
    url: string
  }[]
}

const UploadFeaturesDocList = ({ documents }: Props) => {
  const { id: deviceId } = useParams()
  const [deleteDoc] = useDeleteFeaturesDocMutation()
  const [activeId, setActiveId] = useState(0)
  const [openDialogSave, setOpenDialogSave] = useState(false)
  const getFileIcon = (fileName: string) => {
    const extension = fileName.toLowerCase().split('.').pop()
    switch (extension) {
      case 'pdf':
        return <IconPDF />
      case 'doc':
      case 'docx':
        return <IconDOC />
      case 'xls':
      case 'xlsx':
        return <IconXLS />
      case 'png':
      case 'jpg':
      case 'jpeg':
        return <IconImage />
      default:
        return <IconFile />
    }
  }

  const handleDownload = async (url: string, fileName: string) => {
    try {
      const response = await fetch(url)
      const blob = await response.blob()

      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(blobUrl)
    } catch (error) {
      console.error('Ошибка при скачивании файла:', error)
      notifyError('Произошла ошибка при скачивании файла')
    }
  }
  const handleDelete = (id: number) => {
    try {
      deleteDoc({
        deviceId: Number(deviceId),
        id: id,
      })
      setOpenDialogSave(false)
    } catch (e) {
      console.log(e)
      notifyError('Ошибка')
    }
  }
  return (
    <div className={styles.Wrapper}>
      <Dialog
        message='Документ будет удален. Вы уверены?'
        open={openDialogSave}
        handleClose={() => setOpenDialogSave(false)}
        handleAgree={() => {
          handleDelete(activeId)
        }}
      />
      {documents.map((item) => (
        <div
          key={item.id}
          className={styles.Item}
          onClick={() => handleDownload(item.url, item.name)}
          style={{ cursor: 'pointer' }}
        >
          <span
            className={styles.IconDelete}
            onClick={(e) => {
              e.stopPropagation()
              setActiveId(item.id)
              setOpenDialogSave(true)
            }}
          >
            <IconCancel />
          </span>
          {getFileIcon(item.name)}
          <p className={styles.Text}>{item.name}</p>
        </div>
      ))}
    </div>
  )
}

export default UploadFeaturesDocList
